



































































import Modal from "../core/Modals/Modal.vue";
import MailEditor from "../core/Forms/MailEditor.vue";
import { Email } from "../models/Email";
import { EmailApi } from "../api/EmailApi";
import { SettingApi } from "../api/SettingApi";
import { Employe } from "../models/Employe";
import Absence = Employe.Absence;
import { Setting } from "../models/Setting";
import StringUtils from "../utils/StringUtils";
import { EmployeApi } from "../api/EmployeApi";
import InputField from "../core/Forms/InputField.vue";
import CoordonneeSelector from "./AbsenceNotificationModalPartials/CoordonneeSelector.vue";
import CollapsiblePanel from "../core/UI/CollapsiblePanel.vue";

export default {
    name: "AbsenceNotificationModal",
    components: {
        CollapsiblePanel,
        CoordonneeSelector,
        InputField,
        Modal,
        MailEditor,
    },
    props: {
        showModal: Boolean,
        absence: Absence,
    },
    data() {
        return {
            step: 0,
            loading: false,
            saving: false,
            emailBodyTemplate: "",
            contacts: [],
            selectedEmails: {},
            emailDatas: {},
            EmployeApi: new EmployeApi(),
            EmailApi: new EmailApi(),
            SettingApi: new SettingApi(),
        };
    },
    methods: {
        getBodyTemplate(): void {
            let self = this;
            let templateName = Setting.settingsKeys.mail_absence_notif_template;
            if (self.absence && self.absence.is_conge) {
                templateName = Setting.settingsKeys.mail_conges_notif_template;
            }
            self.SettingApi.get(templateName).then(function (setting) {
                self.emailBodyTemplate = setting.value;
            });
        },
        replaceMailParams(emailData): void {
            if (!this.absence) {
                return;
            }
            let bodyTemplate = StringUtils.replaceMailParams(
                this.emailBodyTemplate
            );
            emailData.body = _.chain(bodyTemplate)
                .replace("{date_debut}", this.absence.date_debut_str)
                .replace("{date_fin}", this.absence.date_fin_str)
                .replace(
                    "{employe_civilite}",
                    this.absence.employe.civilite_abbr
                )
                .replace(
                    "{absent_e}",
                    this.absence.employe.civilite === Employe.ECivilite.Monsieur
                        ? "absent"
                        : "absente"
                )
                .replace("{employe_nom}", this.absence.employe.nom)
                .replace("{employe_prenom}", this.absence.employe.prenom)
                .value();

            if (this.absence.date_fin) {
                let ifNotDateFinRegexp =
                    /\{if_not_date_fin\}(.*?)\{\/if_not_date_fin\}/g;
                let ifDateFinTagRegexp = /\{\/?if_date_fin\}/g;
                emailData.body = emailData.body.replace(ifNotDateFinRegexp, "");
                emailData.body = emailData.body.replace(ifDateFinTagRegexp, "");
            } else {
                let ifDateFinRegexp = /\{if_date_fin\}(.*?)\{\/if_date_fin\}/g;
                let ifNotDateFinTagRegexp = /\{\/?if_not_date_fin\}/g;
                emailData.body = emailData.body.replace(ifDateFinRegexp, "");
                emailData.body = emailData.body.replace(
                    ifNotDateFinTagRegexp,
                    ""
                );
            }
        },
        // Contacts
        getContacts(): void {
            let self = this;

            self.contacts = [];
            self.selectedEmails = {};
            self.emailDatas = {};

            if (!self.absence) {
                return;
            }
            self.loading = true;
            this.EmployeApi.getAbsenceContacts(this.absence.id, {
                include: "related_contacts",
            }).then(function (res) {
                self.contacts = res;
                _.each(self.contacts, function (contact) {
                    self.selectedEmails[contact.id] = "";
                });
                self.loading = false;
            });
        },
        // Events
        closeModal(): void {
            this.saving = false;
            this.step = 0;
            this.$emit("close-modal");
        },
        nextStep(): void {
            let self = this;

            if (_.every(self.selectedEmails, _.isEmpty)) {
                swal(
                    "Erreur",
                    "Vous devez sélectionner au moins une adresse email.",
                    "warning"
                );
                return;
            }

            _.each(self.contacts, function (contact) {
                if (!_.isEmpty(self.selectedEmails[contact.id])) {
                    self.emailDatas[contact.id] = {
                        to: "",
                        toBcc: self.selectedEmails[contact.id],
                        subject: contact.nom,
                        body: "",
                        reference: self.absence.id,
                        type_notification: Email.ETypeNotification.Email,
                        save_type_notification:
                            Email.ESaveTypeNotification.Absence,
                    };
                    self.replaceMailParams(self.emailDatas[contact.id]);
                }
            });
            self.step++;
        },
        sendMail(): void {
            let self = this;

            self.saving = true;

            _.each(self.emailDatas, function (emailData) {
                self.EmailApi.create(emailData).then(function (res) {
                    self.absence.is_notified = true;
                    self.EmployeApi.saveAbsence(
                        self.absence.employe_id,
                        self.absence
                    ).then(function () {
                        self.closeModal();
                    });
                });
            });
        },
    },
    watch: {
        absence: {
            immediate: true,
            deep: true,
            handler: function (newVal) {
                this.getContacts();
                this.getBodyTemplate();
            },
        },
    },
};
